<template>
  <div
    class="editor-input-container"
    :class="[
      `editor-input-container-${styleType}`,
      { 'editor-input-container-border': border },
    ]"
  >
    <div v-if="label" class="editor-input-label flex items-center">
      {{ label }}
      <slot name="edit"></slot>
    </div>
    <el-input
      :value="value"
      :placeholder="placeholder"
      v-bind="$attrs"
      @input="handleInput"
      @focus="focus"
      @blur="blur"
    ></el-input>
  </div>
</template>
<script>
export default {
  name: "EditorInput",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    styleType: {
      type: String,
      default: "",
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
    focus() {
      this.$emit("focus");
    },
    blur() {
      this.$emit("blur");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.editor-input-container {
  display: flex;
  flex-direction: column;
  .editor-input-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .el-input,
  .el-textarea {
    ::v-deep(.el-input__inner),
    ::v-deep(.el-textarea__inner) {
      border-color: transparent !important;
      background-color: $page-bg-sub-color;
      color: $text-color;
      &:focus,
      &:hover {
        border-color: $hover-border-color !important;
        // border-color: transparent;
      }
      &::placeholder {
        color: $placeholder-color;
      }
    }
    ::v-deep(.el-input__suffix-inner) {
      .el-input__count-inner {
        background: transparent;
        color: #5a616e;
        font-size: 14px;
      }
    }
  }
  &.editor-input-container-1 {
    .el-input,
    .el-textarea {
      ::v-deep(.el-input__inner),
      ::v-deep(.el-textarea__inner) {
        background-color: $modal-input-bg1-color !important;
      }
    }
  }
  &.editor-input-container-2 {
    .el-input,
    .el-textarea {
      ::v-deep(.el-input__inner),
      ::v-deep(.el-textarea__inner) {
        background-color: $modal-input-bg2-color !important;
      }
    }
  }
  &.editor-input-container-border {
    .el-input,
    .el-textarea {
      border: 1px solid $modal-input-border-color !important;
      border-radius: 6px;
    }
  }
}
</style>
